import React, { useEffect, useState } from "react"
import axios from "axios"
import { useHistory } from "react-router-dom"
import RDReportHTML from "./RDReportHTML"
import LoadingComponent from "common/LoadingComponent"

const RDZero = props => {
  const setAuth = props.setAuth()
  const history = useHistory()
  const SpecialSystem = props.SpecialSystem?.SpecialSystem || []
  const userId = localStorage.getItem("id")

  let projectid = props.projectId
  let ticketanswers
  let ticketRD6
  let ticketmultitext

  const [response, setResponse] = useState(null)
  const [QuestionData, setQuestionData] = useState([])
  const [loading, setLoading] = useState(true)

  // ***** Preparing showing and hiding questions *************
  let ignoredQuestionsIds = ["476", "343", "344", "345", "346"]
  SpecialSystem.map(item => {
    if (item === "437") {
      // ignoredQuestionsIds.push("233")
      ignoredQuestionsIds = ignoredQuestionsIds.filter(id => id !== "476")
    }
    if (item === "438") {
      ignoredQuestionsIds = ignoredQuestionsIds.filter(id => id !== "343")
    }
    if (item === "439") {
      ignoredQuestionsIds = ignoredQuestionsIds.filter(id => id !== "344")
    }
    if (item === "440") {
      ignoredQuestionsIds = ignoredQuestionsIds.filter(id => id !== "345")
    }
    if (item === "441") {
      ignoredQuestionsIds = ignoredQuestionsIds.filter(id => id !== "346")
    }
  })

  // ***********Show All Questions ************
  function handleAnswersFrom_DataBase(numberAnswers, item) {
    let answerArray = []
    for (let i = 0; i < numberAnswers; i++) {
      answerArray.push({
        value: item["OptionTitle" + i],
        id: item["QOID" + i],
        Hint: item["AHint" + i],
        default: item["DefaultValue" + i],
        operator: item["Operator" + i],
      })
    }
    return answerArray
  }

  const [notRequiredQutions,setNotRequiredQuestions] = useState([])

  useEffect(() => {
    let questionscollect = []
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      SectionID: props.id,
    }
    axios
      .post(process.env.REACT_APP_API_URL+"api/RD3/show_rd3_all.php", formData)
      .then(questions => {
        if (
          questions.data.error === true &&
          questions.data.message === "Access denied!"
        ) {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let array = Object.entries(questions.data)
        const getchildernQuestions = QID => {
          return array.filter(item => item[1].ParentQID === QID)
        }
        array.splice(-1)
        array.forEach(item => {
          questionscollect.push({
            QTitle: item[1].QTitle,
            QID: item[1].QID,
            Answers: handleAnswersFrom_DataBase(item[1].OptionsCount, item[1]),
            AnswerType: item[1].AnswerType,
            childrenQuestions: getchildernQuestions(item[1].QID),
            QHint: item[1].QHint,
            ParentAID: item[1].ParentAID,
            ParentQID: item[1].ParentQID,
            children: [],
            childrenLevel3: [],
            allLevel3: [],
            Other: item[1].Other,
            QHelp: item[1].QHelp,
            MissingData: item[1].MissingData,
            SingleDropdown: item[1].Single,
            initialChildrenCheck: false,
            initialChildrenCheckLevel3: false,
            AnswersChecked: [],
            AnswersCheckedlevel3: [],
            order: item[1].QuestionOrder,
          })
        }) //end of push

        // Showing and Hiding Questions as comming from special system

        ignoredQuestionsIds.map(id => {
          questionscollect = questionscollect.filter(item => item.QID !== id)
        })

        let sortedarray = [...questionscollect].sort(
          (a, b) => a.order - b.order
        )

        setQuestionData(sortedarray)
        if(props.id==="139"){
          setNotRequiredQuestions(sortedarray.map(item=>item.QID))
        }
      }) //end of foreach
  }, [])


  /******* Answers comming from database **********/
  const [dataBaseAnswers, setDataBaseAnswers] = useState([])
  const [dataValues, setDataValues] = useState({})
  const [databaseResponse, setDatabaseResponse] = useState(false)

  useEffect(() => {
    databaseResponse == true && (document.body.style.overflow = "unset")
  })

  useEffect(() => {
    let defaultvalue = {}
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ProjectID: props.projectId,
    }
    axios
      .post(process.env.REACT_APP_API_URL+"api/RD3/AllRD3QAnswers.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)

          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }
        setDatabaseResponse(!databaseResponse)

        let array = Object.entries(res.data)
        array.splice(-1)
        let answers = array.filter(answer => {
          return answer[1].SectionID == props.id
        })
        
        answers && setDataBaseAnswers(answers)

        answers.forEach(answerdata => {
          // 
          let answer = answerdata[1]
          if (answer.MissingData === "1") {
            defaultvalue[`${answer.AnswerType}${answer.QID}`] = "MD"
            defaultvalue[`${answer.AnswerType}Multi${answer.QID}`] &&
              (defaultvalue[`${answer.AnswerType}Multi${answer.QID}`] = "MD")
          } else {
            if (answer.AnswerType === "Integer") {
              defaultvalue[`Integer${answer.QID}`] = answer.Answers[0]
              // 
            }

            if (answer.AnswerType === "Radio") {
              defaultvalue[`Radio${answer.QID}`] = answer.OptionIDs[0]
              if (answer.Answers.length > 0) {
                defaultvalue[`otherRadio${answer.QID}`] = answer.Answers[0]
              }
            }

            if (answer.AnswerType === "Boolean") {
              defaultvalue[`Boolean${answer.QID}`] = answer.OptionIDs[0]
            }
            // 
            if (answer.AnswerType === "CheckBox") {
              if (answer.OptionIDs[0] === null) {
                defaultvalue[`CheckBox${answer.QID}`] = answer.OptionIDs[0]
              } else {
                defaultvalue[`CheckBox${answer.QID}`] = answer.OptionIDs
              }
              if (answer.AnswerType === "CheckBox") {
                if (answer.OptionIDs[0] === null) {
                  defaultvalue[`CheckBox${answer.QID}`] = answer.OptionIDs[0]
                } else {
                  defaultvalue[`CheckBox${answer.QID}`] = answer.OptionIDs
                }
                if (answer.Answers.length > 0) {
                  
                  
                  defaultvalue[`otherCheckBox${answer.QID}-length`]= answer.Answers.length+1 
                  answer.Answers.map(
                    (checklistOther, i) =>
                      (defaultvalue[`otherCheckBox${answer.QID}-${i + 1}`] =
                        checklistOther)
                  )
                }
              }
            }

            if (answer.AnswerType === "Dropdown" && answer.Single == "1") {
              defaultvalue[`Dropdown${answer.QID}`] = answer.OptionIDs[0]
            }

            if (answer.AnswerType === "Dropdown" && answer.Single == "0") {
              if (answer.OptionTitle === "tickRD6") {
                ticketRD6 = answer.Answers
              } else if (answer.OptionTitle === "ticks") {
                ticketmultitext = answer.Answers
              } else {
                ticketanswers = answer.Answers
              }
              if (answer.Answers.length > 0) {

                defaultvalue[`Dropdown${answer.QID}-length`]= answer.Answers.length
                answer.Answers.map((item, i) => {
                  defaultvalue[`Dropdown${answer.QID}-Answer${i + 1}`] =
                    answer.Answers[i]
                  defaultvalue[`Dropdown${answer.QID}-AnswerAR${i + 1}`] =
                    answer.AnswerAR[i]
                  defaultvalue[`Dropdown${answer.QID}-RSelect${i + 1}`] =
                    answer.RSelect[i]
                  defaultvalue[`Dropdown${answer.QID}-CSelect${i + 1}`] =
                    answer.CSelect[i]
                  defaultvalue[`Dropdown${answer.QID}-Term${i + 1}`] =
                    answer.Term[i]
                  defaultvalue[`Dropdown${answer.QID}-TermAR${i + 1}`] =
                    answer.TermAR[i]
                })
              }
            }

            if (answer.AnswerType === "Text") {
              defaultvalue[`Text${answer.QID}`] = answer.Answers[0]
            }

            if (answer.AnswerType === "File") {
              defaultvalue[`File${answer.QID}`] = answer.Answers
            }

            if (answer.AnswerType === "Date") {
              defaultvalue[`Date${answer.QID}`] = answer.Answers[0]
            }
          }
        })
      })
      .catch(err =>
         console.log("error",err)
       )

    setDataValues(defaultvalue)
  }, [])

  //****Preparing disabled of comming miss data ****
  let missObject = {}
  QuestionData.filter(Q => Q.MissingData).map(item => {
    missObject[`${item.AnswerType}${item.QID}`] = React.createRef()
  })

  //****** missing Data ******
  const disableAndClearNode = node => {
    node.disabled = true
    node.checked = false
    node.value = null
  }

  const processQuestion = question => {
    if (question[1]?.current?.checked) {
      let missID = question[1].current.id.slice(8)
      let childNodes = document
        .getElementById(`answerOfQ${missID}`)
        .getElementsByTagName("*")
      for (var node of childNodes) {
        disableAndClearNode(node)
      }
    }
  }

  useEffect(() => {
    let missDataQuestions = Object.entries(missObject)
    missDataQuestions.forEach(processQuestion)
  }, [missObject])
  // ********* missing data function ********
  const [missData, setMissData] = useState([])

  const removeChildern = (questionId, values) => {
    let tempQuestionData = [...QuestionData]
    tempQuestionData = tempQuestionData.map(item => {
      if (item.children && item.QID === questionId) {
        item.children.forEach(item => {
          delete values[`${item.AnswerType}${item.QID}`]
          Object.keys(dataValues).length !== 0 &&
            (dataValues[`${item.AnswerType}${item.QID}`] = "")
        })
        item.children = []
      }
      return item
    })
    setQuestionData(tempQuestionData)
  }

  const add_or_delete_in_missingArray = (
    target,
    questionId,
    clickedQuestion,
    values
  ) => {
    if (target.checked) {
      delete values[`${clickedQuestion.AnswerType}${clickedQuestion.QID}`]
      Object.keys(dataValues).length !== 0 &&
        delete dataValues[`${clickedQuestion.AnswerType}${clickedQuestion.QID}`]
      let tempAnswerIds = [...missData]
      tempAnswerIds.push(questionId)
      setMissData(tempAnswerIds)
    } else {
      let tempAnswerIds = [...missData]
      tempAnswerIds.splice(missData.indexOf(questionId), 1)
      setMissData(tempAnswerIds)
    }
  }

  const handleChildNodes = (
    target,
    questionId,
    clickedQuestion,
    values,
    errors
  ) => {
    let childNodes = document
      .getElementById(`answerOfQ${questionId}`)
      .getElementsByTagName("*")

    if (target.checked) {
      delete errors[`${clickedQuestion.AnswerType}${clickedQuestion.QID}`]
      for (let node of childNodes) {
        node.disabled = true
        node.checked = false
        node.value = null
      }
    } else {
      errors[`${clickedQuestion.AnswerType}${clickedQuestion.QID}`] = "Required"
      for (let node of childNodes) {
        node.disabled = false
      }
    }
  }

  const missingData = (target, values, errors) => {
    
    let questionId = target.id.slice(8)
    let clickedQuestion = QuestionData.filter(
      item => item.QID === questionId
    )[0]
    // 

    removeChildern(questionId, values)
    add_or_delete_in_missingArray(target, questionId, clickedQuestion, values)
    handleChildNodes(target, questionId, clickedQuestion, values, errors)
    // 
  }

  // ***** preparing child question array for => validation *********
  let childQuestionArray = []
  let childQuestionArrayLevel3 = []

  QuestionData.map(item => {
    if (item.children.length > 0) {
      childQuestionArray = [...childQuestionArray, ...item.children]
      item.children.map(child => {
        if (child.childrenLevel3.length > 0) {
          childQuestionArrayLevel3 = [
            ...childQuestionArrayLevel3,
            ...child.childrenLevel3,
          ]
        }
      })
    }
  })

  //****************************** child questions ****************************//
  const childQuestion = []
  for (let item in QuestionData) {
    QuestionData[item].ParentAID && childQuestion.push(QuestionData[item])
  }
  const [defaultArray, setDefaultArray] = useState([])

  // ******** preper options for Dropdown ***************
  /* let answersDropDownArray = []
  // QuestionData.map((item, index) => {
  //   item.AnswerType == "Dropdown" &&
  //     answersDropDownArray.push({
  //       answerId: item.QID,
  //       answers: [],
  //     })
  //   answersDropDownArray.map(answer => {
  //     item.QID == answer.answerId &&
  //       item.Answers.map(itemAnswer =>
  //         answer.answers.push({
  //           options: [{ label: itemAnswer.value, value: itemAnswer.id }],
  //         })
  //       )
  //   })
  // })*/

  const [error, setError] = useState({})

  const PreviousFunc = () => {
    if (props.submittedKey - 1 >= 1) {
      props.setActiveTab((props.submittedKey - 1).toString())
    }
  }

  // for redirecting to reports page after submitting
  const [tickets, setTickets] = useState([])

  useEffect(() => {
    if (props.activeTab == props.tabsLength) {
      const formData = {
        PerToken: localStorage.getItem("token"),
        PerUserID: localStorage.getItem("id"),
        PerRoleID: localStorage.getItem("userRoleID"),
        ProjectID: projectid,
      }
      axios
        .post(process.env.REACT_APP_API_URL+"api/Rd0TicketsList.php", formData)
        .then(res => {
          if (
            res.data.error === true &&
            res.data.message === "Access denied!"
          ) {
            setAuth(true)
            setTimeout(() => {
              history.push("/logout")
              setTimeout(() => {
                history.push("/login")
              }, 1000)
            }, 4000)
          }

          if (res.data.error === false) {
            let array = Object.values(res.data)
            array.splice(-1)
            setTickets(array)
          }
        })
        .catch(err => console.log("error",err) )
    }
  }, [props.activeTab])

  useEffect(() => {
    if (response)
      {
        history.push("/rd3-reports")
      }
  }, [response])

 
  //******************************************* component ************************************************//
  return (
    <>
      <RDReportHTML
      notRequiredQutions={notRequiredQutions}
        dataValues={dataValues}
        QuestionData={QuestionData}
        childQuestionArray={childQuestionArray}
        childQuestionArrayLevel3={childQuestionArrayLevel3}
        props={props}
        error={error}
        SpecialSystem={SpecialSystem}
        userId={userId}
        projectid={projectid}
        setResponse={setResponse}
        setLoading={setLoading}
        history={history}
        setAuth={setAuth}
        missData={missData}
        defaultArray={defaultArray}
        setError={setError}
        missingData={missingData}
        setMissData={setMissData}
        Boolean={Boolean}
        dataBaseAnswers={dataBaseAnswers}
        childQuestion={childQuestion}
        setQuestionData={setQuestionData}
        PreviousFunc={PreviousFunc}
     
        loading={loading}
        missObject={missObject}
        ticketanswers={ticketanswers}
        ticketRD6={ticketRD6}
        ticketmultitext={ticketmultitext}
        refAP={props.refAP}
        setDataBaseAnswers={setDataBaseAnswers}
        setDataValues={setDataValues}
      />
      <LoadingComponent
        response={databaseResponse}
        setResponse={setDatabaseResponse}
      />
    </>
  )
}

export default React.memo(RDZero)
